<template>
    <tg-dialog
        ref="dialog"
        :title="title"
        v-bind="{ ...$attrs }"
        v-on="$listeners"
        :visible.sync="visible"
        :showIcon="false"
        :showFooter="true"
        :showCancelBtn="true"
        :confirmLabel="confirmLabel"
        :cancelLabel="cancelLabel"
        width="35%"
        @on-confirm="handleConfirm"
        @on-cancel="handleCancel"
        :disableConfirmBtn="checkBoxClear"
        :confirmBtnClass="confirmBtnClass"
        class="tg-member-privilege-bulk-dialog"
    >
        <template v-for="(item, index) in third_party_array">
            <!-- 篩選掉沒用到的類別 -->
            <template 
                v-if="item"
            >
                <!-- 功能 | 全選 -->
                <el-row
                    type="flex"
                    justify="start"
                    align="middle"
                    :key="'a' + index"
                >
                    <span>{{ $t("enum.source_type[" + index + "]") }}</span>
                    <span class="mb-3">|</span>
                    <span
                        class="text-primary clickable"
                        @click="toggleSelectAll(index)"
                    >
                        {{ $t("enum.select_all[" +(selectAll[index] ? 0 : 1) +"]") }}
                    </span>
                </el-row>

                <el-row type="flex" justify="start" align="middle" :key="index" >
                    <el-checkbox-group v-model="functional[index]">
                        <template v-for="value in item">
                            <el-checkbox
                                :label="value.platform"
                                :key="value.platform"
                                @change="handleFunctionalChange(index)"
                                :style="{width:maxLabelWidth+'px'}"
                            >
                                {{ $t("component.label.source_type." + value.platform) }}
                            </el-checkbox>
                        </template>
                    </el-checkbox-group>
                </el-row>
            </template>
        </template>
    </tg-dialog>
</template>

<script>
// import apis from "@/apis";
import TgDialog from "@/components/dialog/TgDialog";

export default {
    inheritAttrs: false,
    components: {
        TgDialog,
    },
    data() {
        return {
            visible: false,
            selectAll: [true, true, true, true, true, true, true],
            response: [],

            functional: {
                0: [],
                1: [],
                2: [],
                3: [],
                4: [],
                5: [],
                6: [],
            },
            third_party_array: [[{ platform: "tg", catrgory: 0 }]], //彈窗的值
            maxLabelWidth: 0,
        };
    },
    props: {
        third_party: Array,
        isNotAccount: Boolean,
    },
    computed: {
        title() {
            return this.$t("component.btn.source_type_choose");
        },
        confirmLabel() {
            return this.$t("component.btn.confirm");
        },
        cancelLabel() {
            if(this.checkBoxClear){
                return this.$t("component.btn.all");
            }else{
                return this.$t("component.btn.clear");
            }
            
        },
        selected() {
            let selected = [];
            Object.keys(this.functional).forEach((category) => {
                let platforms = this.functional[category].map((p) => {
                    let item = this.third_party_array[category].find(
                        (x) => x.platform == p
                    );
                    return item;
                });
                selected.push.apply(selected, platforms);
            });

            return selected;
        },
        checkBoxClear(){
            return this.selected.length == 0;
        },
        confirmBtnClass(){
            if(this.checkBoxClear){
                return [];
            }else{
                return ['confirm'];
            }
        },
    },
    created() {
        let array = new Array();
        array[0] = { platform: "tg", category: 0 };
        if (this.isNotAccount) {
            this.thirdParties.forEach((element) => {
                array.push(element);
                if (element.functional != null) {
                    for (let key in element.functional) {
                        if (key == "1000" && element.functional[key] == "0") {
                            array.splice(array.length - 1, 1);
                        }
                    }
                }
            });
        } else {
            if (this.thirdParties.length > 0) {
                this.thirdParties.forEach((element) => {
                    array.push(element);
                });
            }
        }

        // 根據category分類平台
        this.third_party_array = new Array();
        array.forEach((element) => {
            if (!this.third_party_array[element.category]) {
                this.third_party_array[element.category] = new Array();
                this.functional[element.category] = new Array();
                this.selectAll[element.category] = true;
            }
            this.third_party_array[element.category].push(element);
            if(Object.keys(this.third_party).length == 0){
                this.functional[element.category].push(element.platform);
            }
        });

        let maxWidth = 0;
        this.third_party_array.forEach(item => {
            item.forEach(element =>{
                if((this.$t("column."+element.platform).replace(/[\u4E00-\u9FFF]/g,"xx").length)*8 > maxWidth){
                    maxWidth = this.$t("column."+element.platform).replace(/[\u4E00-\u9FFF]/g,"xx").length*8;
                }
            });
        });
        this.maxLabelWidth = maxWidth+25;

        if(Object.keys(this.third_party).length != 0){
            this.third_party.forEach(element=>{
                if (Array.isArray(this.functional[element.category])) {
                    this.functional[element.category].push(element.platform);
                }
            });
        }
        this.$emit("on-click", this.selected);
        // apis.getThirdPartys().then((response) => {
        //     let array = new Array();
        //     array[0] = { platform: "tg", category: 0 };
        //     if (this.isNotAccount) {
        //         response.data.forEach((element) => {
        //             array.push(element);
        //             if (element.functional != null) {
        //                 for (let key in element.functional) {
        //                     if (key == "1000") {
        //                         array.splice(array.length - 1, 1);
        //                     }
        //                 }
        //             }
        //         });
        //     } else {
        //         if (response.retcode == 0) {
        //             response.data.forEach((element) => {
        //                 array.push(element);
        //             });
        //         }
        //     }

        //     // 根據category分類平台
        //     this.third_party_array = new Array();
        //     array.forEach((element) => {
        //         if (!this.third_party_array[element.category]) {
        //             this.third_party_array[element.category] = new Array();
        //             this.functional[element.category] = new Array();
        //             this.selectAll[element.category] = true;
        //         }
        //         this.third_party_array[element.category].push(element);
        //         if(Object.keys(this.third_party).length == 0){
        //             this.functional[element.category].push(element.platform);
        //         }
        //     });
        //     if(Object.keys(this.third_party).length != 0){
        //         this.third_party.forEach(element=>{
        //             this.functional[element.category].push(element.platform);
        //         });
        //     }
        //     this.$emit("on-click", this.selected);
        // });
    },
    methods: {
        showDialog() {
            this.visible = true;
        },
        toggleFunctional(selectAll, index) {
            // 相反操作
            this.functional[index] = !selectAll
                ? []
                : this.third_party_array[index].reduce((a, b) => {
                      a.push(b.platform);
                      return a;
                  }, []);
        },
        toggleSelectAll(index) {
            // 相反操作
            this.selectAll[index] = !this.selectAll[index];
            this.toggleFunctional(this.selectAll[index], index);
        },
        handleConfirm() {
            let selected = [];
            if(this.selected.length == 0){
                this.functional[0] = ['tg'];
                selected = [{'platform':'tg','category':0}]
            }else{
                selected = this.selected;
            }
            this.$emit("on-click", selected);
        },
        handleCancel(e) {
            e.preventDefault = true;
            if(this.selected){
                let checkBoxClear = this.checkBoxClear;
                Object.keys(this.functional).forEach((category) => {
                    if(checkBoxClear){
                        if(this.functional[category].length == 0 && this.third_party_array[category] && this.third_party_array[category].length != 0){
                            this.toggleSelectAll(category);
                        }
                    }else if(this.functional[category].length > 0){
                        this.functional[category] = [];
                        this.selectAll[category] = false;
                    }
                });
            }else{
                Object.keys(this.functional).forEach((category) => {
                    this.functional[category] = [];
                    this.selectAll[category] = false;
                });
            }
        },
        handleFunctionalChange(index) {
            if (
                this.functional[index].length ==
                this.third_party_array[index].length
            ) {
                this.selectAll[index] = true;
            } else {
                this.selectAll[index] = false;
            }
        },
    },
    watch: {
        third_party(value) {
            let selected = value.reduce((a, c) => {
                if (!a[c.category]) {
                    a[c.category] = [];
                }
                a[c.category].push(c.platform);
                return a;
            }, {});

            let functional = { ...this.functional };
            let selectAll = [];
            let allClear = true;
            Object.keys(functional).forEach((category) => {
                functional[category] = !selected[category]
                    ? []
                    : selected[category];
                selectAll[category] = !selected[category] ? false : true;

                if (selected[category]) {
                    allClear = false;
                }
            });

            if (allClear) {
                functional[0] = ["tg"];
                selectAll[0] = true;
            }
            
            this.functional = functional;
            this.selectAll = selectAll;
        },
    },
};
</script>
